/* @flow */

import * as React from 'react';
import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

type TypeProps = {|
  formData: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class AddNewSystemSuccess extends React.Component<*> {
  componentDidMount() {
    const { actionDrawerStore }: TypeProps = this.props;
    const parentForm: Object = this.props.parentForm;
    const model: Object = this.props.model;
    const childmodel: Object = this.props.childmodel;

    // System
    const field: Object = parentForm.$('location.locationSystem');
    const fieldExtra: Object = field.extra;

    field.set('value', actionDrawerStore.response.name);
    field.set('extra', { ...fieldExtra, selectID: actionDrawerStore.response.id });
    // IDs should be returned in success save of locations
    model.filterId =
      `/${parentForm.$('location.locationCompany').extra.selectID}` +
      `/${parentForm.$('location.countryId').value}` +
      `?parent_id=${parentForm.$('location.locationRoom').extra.selectID}`;
    model.parentId = parentForm.$('location.locationRoom').extra.selectID;
    model.search = '';
    model.loadData();

    // Reset System
    // No child

    actionDrawerStore.closeActionDrawer();
  }

  render(): React.Element<*> {
    return 'success';
  }
}
